import React from "react"
import PropTypes from "prop-types"
import readingTime from "reading-time/lib/reading-time"

const ReadingTime = ({ data }) => {
  const result = readingTime(data)

  return <p>{result.text}</p>
}

ReadingTime.propTypes = {
  data: PropTypes.string,
}

export default ReadingTime
